import React, { Component } from "react";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    login_action,
    forgetPassword_action,
    getOtp_action,
    update_action,
    signUp_action
} from "../../actions/user_login_auth_actions/user_login_auth_action";
import { withRouter } from "../../utils/withRouter";
import Loader from "../../utils/Loader";
import { clearSessionStorage, toastError, toastSuccess } from "../../utils/constants";
// import Header from '../../common_components/Header';
import {
    emailValidator,
    loginPasswordValidator,
    loginEmailValidator,
    otpValidator,
    confirmPasswordValidator,
    passwordValidator,
    mobileNoValidator
} from "../../utils/Validator";
import Modal from "react-modal";
import jQuery from "jquery";
import $ from "jquery";
import ReactDatePicker from "react-datepicker";
import { booking_Details_action } from "../../actions/bookingDetails_action/bookingDetails_action";
import { Password } from "@mui/icons-material";
// import Footerlogin from '../../common_components/Footerlogin';
// import AdminHeader from '../../common_components/admin_module_header';

/*
 * mapDispatchToProps
 */
// const mapDispatchToProps = dispatch => ({
//     loginAction: () => dispatch(loginAction())
// })

/*
 * mapStateToProps
 */

// const mapStateToProps = state => {
//   return {
//     loginData: state,
//   };
// }

class PreLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Email: "",
            password: "",
            is_showpass: false,
            email: "",
            is_forgotPassword: false,
            isLoading: false,
            is_rememberme: false,
            is_verifyEmail: false,
            is_verifyOTP: false,
            verifyEmail: "",
            userName: "",
            getOtp: "",
            adminOtp: "",
            forgetNewPass: "",
            forgetConfirmPass: "",
            finalForgetButton: false,
            companyInfo: false,

            //forget
            forgetPassEmail: "",
            OTP: "",
            newPassword: "",
            confirmPassword: "",
            CenterID: "",

            OrderID: "",

            signName: '',
            signEmail: '',
            signMobileNo: '',
            signPassword: '',
            signOTP: '',
            isOtpView: false,
            submitSignOTP: '',
            count: 0,
            otpVerifyFlag: false
        };
        this.intervalId = null
        this.toggleModal = this.toggleModal.bind(this);
        // this.handleKeyDown = this.handleKeyDown.bind(this)
        // this.forgetPassword = this.forgetPassword.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this);
        this.jQuerycode = this.jQuerycode.bind(this);
    }

    componentDidMount() {
        this.jQuerycode();
        this.setState({
            companyInfo:
                this.props.location.state != null &&
                    this.props.location.state.companyInfo != null
                    ? this.props.location.state.companyInfo
                    : false,

            CenterID:
                this.props.location.state != null &&
                    this.props.location.state.CenterID != null
                    ? this.props.location.state.CenterID
                    : "",
        });

        setTimeout(() => {
            console.log("login props", this.props);
        }, 200);

        var url;
        if (
            this.props.location.pathname != null &&
            this.props.location.pathname.includes("/login/")
        ) {
            url =
                this.props.location.pathname != null &&
                this.props.location.pathname.split("/login/");
            this.setState({
                OrderID: url != "" ? (url[1] != "" ? url[1].toString() : "") : "",
            });
        }
    }

    jQuerycode = () => {
        // SLIDESHOW

        $(function () {
            $("#slideshow > div:gt(0)").hide();
            setInterval(function () {
                $("#slideshow > div:first")
                    .fadeOut(1000)
                    .next()
                    .fadeIn(1000)
                    .end()
                    .appendTo("#slideshow");
            }, 3850);
        });
    };

    startCounting = () => {
        this.setState({ count: 30 }); // Set count to 30
        clearInterval(this.intervalId); // Clear any previous interval
        this.intervalId = setInterval(this.decrementCounter, 1000); // Start new interval to decrement count
    };

    // Function to decrement the counter
    decrementCounter = () => {
        this.setState(prevState => ({
            count: prevState.count - 1
        }), () => {
            if (this.state.count === 0) {
                clearInterval(this.intervalId); // Stop counting when count reaches 0
            }
        });
    };

    handleSubmit(event) {
        console.log(event.key, "keycode")
        // if (event.key === "Enter" || event.key === "NumpadEnter") {
        event.preventDefault();
        const { Email, password, companyInfo, OrderID } = this.state;
        // this.props.navigate("/dashboard");
        const Status =
            this.props.location.state != null ? this.props.location.state.status : "";
        const myOrderStatus =
            this.props.location.state != null ? this.props.location.state.status : "";
        console.log("----------------", myOrderStatus, this.props.location.state);
        // console.log("testing-------------->", Email, password)
        // console.log("Status-------------->******************************", Status)
        var errMsg = loginEmailValidator(Email);
        var errMsg2 = loginPasswordValidator(password);
        if (errMsg != "" || errMsg2 != "") {
            toast.error(errMsg != "" ? errMsg : errMsg2 != "" ? errMsg2 : "", {
                position: "top-center",
                theme: "colored",
                autoClose: 1000,
                hideProgressBar: true,
            });
        } else {
            if (Email != " " && password != " ") {
                this.setState({ isLoading: true });
                this.props
                    .login_action(Email.toString().trim(), password.toString().trim())
                    // .login_action(Email.toString().trim(), password.toString().trim())
                    .then((data) => {
                        // console.log("Data12122121 ", data)
                        // console.log("Data12122121 ", data.msg)

                        if (data.error != 1) {
                            setTimeout(() => {

                                this.props.navigate("/bookNow");
                                this.setState({ isLoading: false });
                            }, 2000);

                        } else {
                            this.setState({ isLoading: false });
                            toast.error(data.msg, {
                                position: "top-center",
                                theme: "colored",
                                autoClose: 3000,
                                hideProgressBar: true,
                            });
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                    });
            } else {
                this.setState({ isLoading: false });

                toast.error("Please check user name and password", {
                    position: "top-center",
                    theme: "colored",
                    autoClose: 1000,
                    hideProgressBar: true,
                });
            }
        }
        // }
    }

    handleKeyDown(e) {
        if (e.code === "Enter") {
            this.handleSubmit(e);
        }
    }

    handleKeyDownSignUp(e) {
        if (e.code === "Enter") {
            this.signUp(e);
        }
    }

    onVerifyOTP() {
        const { getOtp, is_verifyOTP, is_verifyEmail, adminOtp } = this.state;
        // this.props.navigate("/dashboard");
        this.setState(
            {
                adminOtp: sessionStorage.getItem("NODE_OTP"),
            },
            () => {
                // console.log("adminOtp-------------->", adminOtp)
            }
        );

        var errMsg = otpValidator(getOtp);

        setTimeout(() => {
            if (errMsg != "") {
                toast.error(errMsg != "" ? errMsg : "", {
                    position: "top-center",
                    theme: "colored",
                    autoClose: 1000,
                    hideProgressBar: true,
                });
            } else {
                if (getOtp != "") {
                    if (sessionStorage.getItem("NODE_OTP") === getOtp) {
                        this.setState({
                            is_verifyOTP: !is_verifyOTP,
                            is_verifyEmail: !is_verifyEmail,
                        });
                        toast.success("OTP Veryfied", {
                            position: "top-center",
                            theme: "colored",
                            autoClose: 3000,
                            hideProgressBar: true,
                        });
                    } else {
                        toast.error("OTP incorrect!", {
                            position: "top-center",
                            theme: "colored",
                            autoClose: 3000,
                            hideProgressBar: true,
                        });
                    }
                }
            }
        }, 500);
    }

    //toggle model for forgot password.................................

    clearValue() {
        this.setState({
            verifyEmail: "",
            userName: "",
            getOtp: "",
            adminOtp: "",
            forgetNewPass: "",
            forgetConfirmPass: "",
            is_verifyOTP: false,
            is_verifyEmail: false,
        });
    }

    toggleModal() {
        const { is_forgotPassword } = this.state;
        if ($(".recovery").hasClass("open")) {
            $(".recovery").removeClass("open").addClass("closed");
            $("#toggle-terms").removeClass("open").addClass("closed");
        } else {
            $(".recovery").removeClass("closed").addClass("open");
            $("#toggle-terms").removeClass("closed").addClass("open");
            this.clearValue();
            this.setState({ is_forgotPassword: true });
        }
    }

    updatePassword(e) {
        e.preventDefault();
        const { forgetNewPass, forgetConfirmPass, is_forgotPassword } = this.state;
        this.setState({ isLoading: true });
        // this.props.navigate("/dashboard");
        // console.log("testing-------------->", forgetNewPass, forgetConfirmPass)
        var errMsg = passwordValidator(forgetNewPass);
        var errMsg2 = confirmPasswordValidator(forgetNewPass, forgetConfirmPass);
        // console.log(errMsg);
        // console.log(errMsg2);
        if (errMsg != "" || errMsg2 != "") {
            toast.error(errMsg != "" ? errMsg : errMsg2 != "" ? errMsg2 : "", {
                position: "top-center",
                theme: "colored",
                autoClose: 1000,
                hideProgressBar: true,
            });
            this.setState({ isLoading: false });
        } else {
            if (forgetNewPass != "" && forgetConfirmPass != "") {
                this.props
                    .update_action(forgetConfirmPass)
                    .then((data) => {
                        if (data.error != 1) {
                            this.setState({ isLoading: false });
                            toast.success("Password Updated SuccessFully!", {
                                position: "top-center",
                                theme: "colored",
                                autoClose: 1000,
                                hideProgressBar: true,
                            });
                            // document.querySelector(".recovery").style.display = "none";
                            this.toggleModal();
                            this.clearValue();
                        } else {
                            this.setState({ isLoading: false });
                            toast.error(data.msg, {
                                position: "top-center",
                                theme: "colored",
                                autoClose: 3000,
                                hideProgressBar: true,
                            });
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                    });
            }
        }
    }

    // handleKeyDown(e) {
    //   if (e.code === 'Enter') {
    //     this.forgetPassword(e)
    //   }
    // }

    navigateLoginSignUp(data) {
        const { isFlagLoginSignUp } = this.state;
        if (data == 'login') {
            this.setState({ isFlagLoginSignUp: true })
        } else {
            this.setState({ isFlagLoginSignUp: false })
        }
    }

    // this.setState({ is_verifyOTP: !is_verifyOTP, is_verifyEmail: !is_verifyEmail })
    onVerifyEmail(e) {
        const { verifyEmail, is_verifyEmail, is_forgotPassword } = this.state;
        // console.log("testing-------------->", verifyEmail)
        var errMsg = emailValidator(verifyEmail);
        if (errMsg != "") {
            toast.error(errMsg != "" ? errMsg : "", {
                position: "top-center",
                theme: "colored",
                autoClose: 1000,
                hideProgressBar: true,
            });
        } else {
            if (verifyEmail != " ") {
                this.setState({ isLoading: true });
                this.isCheckEmailPresent(e);
            }
        }
    }

    getOtp() {
        const { verifyEmail, is_verifyEmail, is_forgotPassword } = this.state;
        this.props
            .getOtp_action(verifyEmail)
            .then((data) => {
                if (data.error != 1) {
                    // session
                    sessionStorage.setItem("NODE_OTP", data.data);
                    this.setState({ is_forgotPassword: !is_forgotPassword });
                    this.setState({ isLoading: false });
                } else {
                    this.setState({ isLoading: false, email: "" });
                    toast.error(data.msg, {
                        position: "top-center",
                        theme: "colored",
                        autoClose: 3000,
                        hideProgressBar: true,
                    });
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    isCheckEmailPresent(e) {
        e.preventDefault();
        const { verifyEmail, is_verifyEmail, is_forgotPassword } = this.state;
        this.props
            .forgetPassword_action(verifyEmail)
            .then((data) => {
                if (data.error != 1) {
                    toast.success("OTP Send on your Email", {
                        position: "top-center",
                        theme: "colored",
                        autoClose: 3000,
                        hideProgressBar: true,
                    });
                    // console.log("FORG", data.data[0]['UserID'])
                    sessionStorage.setItem("userIdForget", data.data[0]["UserID"]);
                    this.getOtp();
                    this.setState({
                        is_verifyEmail: !is_verifyEmail,
                        is_forgotPassword: !is_forgotPassword,
                    });
                    this.setState({ isLoading: false });
                } else {
                    this.setState({ isLoading: false, email: "" });
                    toast.error(data.msg, {
                        position: "top-center",
                        theme: "colored",
                        autoClose: 3000,
                        hideProgressBar: true,
                    });
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    signUp() {
        const { signName, signEmail, signMobileNo, signPassword, signOTP, } = this.state
        var errMsg1 = mobileNoValidator(signMobileNo)
        var errMsg2 = emailValidator(signEmail)
        var errMsg3 = passwordValidator(signPassword)

        if (signName != '') {
            if (errMsg1 != '' || errMsg2 != '' ) {
                toast.error(
                    errMsg1 != '' ? errMsg1 :
                        errMsg2 != '' ? errMsg2 :
                                '',
                    {
                        position: "top-center",
                        theme: 'colored',

                        autoClose: 1000,
                        hideProgressBar: true,
                    })
            } else {
                this.setState({ isOtpView: true })
                this.signGetOtp()
            }
        } else {
            toastError("please enter name")
        }
    }

    signGetOtp() {
        const { signEmail } = this.state;
        this.startCounting()
        this.props
            .getOtp_action(signEmail)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("OTP sent successfully")
                    this.setState({ isLoading: false, submitSignOTP: data.data });
                } else {
                    this.setState({ isLoading: false });
                    toast.error(data.msg, {
                        position: "top-center",
                        theme: "colored",
                        autoClose: 3000,
                        hideProgressBar: true,
                    });
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    submitSignOTP() {
        const { signName, signEmail, signMobileNo, signPassword, submitSignOTP, signOTP } = this.state
        var errMsg = otpValidator(signOTP);
        if (errMsg != '') {
            toast.error(
                errMsg != '' ? errMsg : '',
                {
                    position: "top-center",
                    theme: 'colored',
                    autoClose: 1000,
                    hideProgressBar: true,
                })
        }
        else {
            if (submitSignOTP == signOTP) {
                toastSuccess("OTP Veryfied")
                this.setState({ otpVerifyFlag: false })
                setTimeout(() => {
                    this.props
                        .signUp_action(signName.toString().trim(), signMobileNo, signEmail, signMobileNo)
                        .then((data) => {

                            if (data.error != 1) {

                                this.props.navigate("/bookNow");

                                this.setState({ isLoading: false });

                            } else {
                                this.setState({ isLoading: false, isOtpView: false, otpVerifyFlag: false, signOTP:'' });
                                toast.error(data.msg, {
                                    position: "top-center",
                                    theme: "colored",
                                    autoClose: 3000,
                                    hideProgressBar: true,
                                });
                            }
                        })
                        .catch((e) => {
                            console.log(e);
                        });
                }, 2000);
            } else {
                toastError("OTP incorrect!")
            }
        }
    }

    render() {
        const {
            Email,
            password,
            isLoading,
            is_rememberme,
            is_verifyEmail,
            is_verifyOTP,
            email,
            is_showpass,
            is_forgotPassword,
            verifyEmail,
            userName,
            getOtp,
            forgetNewPass,
            forgetConfirmPass,
            finalForgetButton,
            isFlagLoginSignUp,
            signName,
            signEmail,
            signMobileNo,
            signPassword,
            signOTP,
            isOtpView,
            otpVerifyFlag
        } = this.state;
        return (
            <>
                {isLoading ? <Loader></Loader> : null}
                <ToastContainer />
                {/* <AdminHeader isSteper={false}/> */}
                <>
                    <main>
                        <div class="login">
                            <div class="wrap">
                                {/* TOGGLE */}
                                <div id="toggle-wrap">
                                    <div id="toggle-terms">
                                        <div id="cross" onClick={this.toggleModal}>
                                            <span></span>
                                            <span></span>
                                        </div>
                                    </div>
                                </div>

                                {/* <!-- RECOVERY --> */}

                                <div class="recovery">
                                    <h6>Forgot Password</h6>
                                    <p>
                                        Enter your <strong>email address</strong> on the account and{" "}
                                        <strong>click Submit</strong>
                                    </p>
                                    <p>We'll email instructions on how to reset your password.</p>

                                    {is_forgotPassword && (
                                        <div className="form">
                                            <input
                                                type="text"
                                                class="input"
                                                id="user_recover"
                                                value={verifyEmail}
                                                placeholder="Enter your Email"
                                                onChange={(e) =>
                                                    this.setState({ verifyEmail: e.target.value })
                                                }
                                                maxLength={50}
                                            />

                                            <input
                                                type="submit"
                                                class="button verify_email w-20px"
                                                value="Verify Email"
                                                onClick={(e) => this.onVerifyEmail(e)}
                                            />
                                        </div>
                                    )}
                                    {is_verifyEmail && (
                                        <div className="form">
                                            <input
                                                type="text"
                                                class="input"
                                                id="user_recover"
                                                value={verifyEmail}
                                                disabled={true}
                                            />
                                            <input
                                                type="text"
                                                class="input"
                                                id="user_recover"
                                                maxLength={6}
                                                placeholder="Enter OTP"
                                                value={getOtp}
                                                onChange={(e) =>
                                                    this.setState({
                                                        getOtp: e.target.value.replace(/\D/, ""),
                                                    })
                                                }
                                            />
                                            <input
                                                type="submit"
                                                class="button verify_OTP"
                                                value="Verify OTP"
                                                onClick={() => this.onVerifyOTP()}
                                            />
                                        </div>
                                    )}
                                    {is_verifyOTP && (
                                        <div className="form">
                                            <input
                                                type="text"
                                                class="input"
                                                id="user_recover"
                                                maxLength={25}
                                                placeholder="New Password"
                                                onChange={(e) =>
                                                    this.setState({ forgetNewPass: e.target.value })
                                                }
                                                value={forgetNewPass}
                                            />
                                            <input
                                                type="text"
                                                class="input"
                                                id="user_recover"
                                                maxLength={25}
                                                placeholder="Confirm Password"
                                                onChange={(e) =>
                                                    this.setState({ forgetConfirmPass: e.target.value })
                                                }
                                                value={forgetConfirmPass}
                                            />
                                            <input
                                                type="submit"
                                                class="button Set_Password"
                                                value="Set Password"
                                                onClick={(e) => {
                                                    this.updatePassword(e);
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>

                                {/* <!-- SLIDER --> */}
                                <div class="content">
                                    <div class="logo">
                                        <a><img src="img/main-logo-green.png" alt="" style={{ width: "220px" }} /></a>
                                    </div>
                                    <img src="/img/down__2__page-0001-removebg-preview.png" class="log-bottom-img" />

                                </div>
                                {/* <!-- LOGIN FORM --> */}
                                <div class="user">
                                    {/* <!-- ACTIONS
                                <div class="actions">
                                  <a class="help" href="#signup-tab-content">Sign Up</a><a class="faq" href="#login-tab-content">Login</a>
                                </div>
                    --> */}
                                    <div class="form-wrap">
                                        {/* <!-- TABS --> */}
                                        <span className="text-danger text-start text-bold text-center d-block mt-1">*Kindly Signup or Login to view the details.</span>
                                        <div class="tabs">
                                        <h3 class="signup-tab" style={{ cursor: 'pointer' }}>
                                                <a
                                                    style={{ textDecoration: "none" }}
                                                    class={!isFlagLoginSignUp ? "sign-up active" : 'sign-up'}
                                                    onClick={() => this.navigateLoginSignUp('signUp')}
                                                >
                                                    <span>Sign Up</span>
                                                </a>
                                            </h3>
                                            <h3 class="login-tab" style={{ cursor: 'pointer' }}>
                                                <a
                                                    style={{ textDecoration: "none" }}
                                                    class={isFlagLoginSignUp ? "log-in active" : 'log-in'}
                                                    onClick={() => this.navigateLoginSignUp('login')}
                                                >
                                                    <span>Login</span>
                                                </a>
                                            </h3>
                                            
                                        </div>
                                        {/* <!-- TABS CONTENT --> */}
                                        <div class="tabs-content">
                                            {/* <!-- TABS CONTENT LOGIN --> */}
                                            {!isFlagLoginSignUp ?
                                                <div id="login-tab-content" class="active form">
                                                    <div class="login-form" action="" method="post">
                                                        <input
                                                            type="text"
                                                            className="input"
                                                            placeholder="Name"
                                                            value={signName}
                                                            onChange={(e) =>
                                                                this.setState({ signName: e.target.value })
                                                            }
                                                            onKeyDown={(e) => this.handleKeyDownSignUp(e)}
                                                            maxLength={50}
                                                            disabled={isOtpView}
                                                            autoComplete="off"
                                                            style={{ background: isOtpView ? '#dfdfdf' : '' }}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="input"
                                                            placeholder="Mobile No"
                                                            value={signMobileNo}
                                                            onChange={(e) =>
                                                                this.setState({ signMobileNo: e.target.value })
                                                            }
                                                            onKeyDown={(e) => this.handleKeyDownSignUp(e)}
                                                            maxLength={10}
                                                            disabled={isOtpView}
                                                            autoComplete="off"
                                                            style={{ background: isOtpView ? '#dfdfdf' : '' }}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="input"
                                                            placeholder="Email"
                                                            value={signEmail}
                                                            onChange={(e) =>
                                                                this.setState({ signEmail: e.target.value })
                                                            }
                                                            onKeyDown={(e) => this.handleKeyDownSignUp(e)}
                                                            maxLength={50}
                                                            disabled={isOtpView}
                                                            autoComplete="off"
                                                            style={{ background: isOtpView ? '#dfdfdf' : '' }}
                                                        />
                                                        {/* <div style={{ overflow: "hidden" }}> */}
                                                        {/* <input
                                                            type={is_showpass ? "text" : "password"} // Change "type" to "text" when is_showpass is true
                                                            class="input"
                                                            placeholder="Password"
                                                            value={signPassword}
                                                            onChange={(e) => this.setState({ signPassword: e.target.value })}
                                                            onKeyDown={(e) => this.handleKeyDownSignUp(e)}
                                                            maxLength={25}
                                                            disabled={isOtpView}
                                                            autoComplete="off"
                                                            style={{ background: isOtpView ? '#dfdfdf' : '' }}
                                                        />
                                                        <i style={{
                                                            color: "black",
                                                            position: "relative",
                                                            fontSize: "20px",
                                                            top: "-44px",
                                                            left: "290px",
                                                            cursor: "pointer"
                                                        }}
                                                            className={`fa ${is_showpass ? "fa-eye-slash" : "fa-eye"} show-password`} // Use "fa-eye-slash" when is_showpass is true
                                                            onClick={() => !isOtpView ? this.setState((prevState) => ({ is_showpass: !prevState.is_showpass })) : ''} // Toggle is_showpass state
                                                        ></i> */}
                                                        <button
                                                            class="btn btn-primary login_btn m-0"
                                                            onClick={(e) => this.signUp(e)}
                                                            disabled={isOtpView}
                                                        >
                                                            Sign Up
                                                        </button>
                                                        {/* </div>s */}
                                                        {isOtpView ?
                                                            <>
                                                                <input
                                                                    type="text"
                                                                    className="input"
                                                                    placeholder="OTP"
                                                                    value={signOTP}
                                                                    onChange={(e) =>
                                                                        this.setState({ signOTP: e.target.value })
                                                                    }
                                                                    onKeyDown={(e) => this.handleKeyDownSignUp(e)}
                                                                    maxLength={6}
                                                                />
                                                                <div style={{ textAlign: 'right', color: this.state.count != 0 ? '#e37680' : '#dc3545', textDecoration: 'underline', cursor: this.state.count == 0 ? 'pointer' : 'default' }} onClick={() => this.state.count == 0 ? this.signGetOtp() : ''}>Resend OTP  {this.state.count != 0 ? this.state.count : ''}</div>
                                                                <span className="text-danger text-start text-left d-block mt-1">Note: OTP is sent your email address</span>
                                                                <input
                                                                    type="submit"
                                                                    class="button verify_OTP"
                                                                    value="Verify OTP"
                                                                    onClick={() => !otpVerifyFlag ? this.submitSignOTP() : ''}
                                                                />
                                                            </>
                                                            : <></>}
                                                    </div>
                                                </div>
                                                : <div id="login-tab-content" class="active form">
                                                <div class="login-form" action="" method="post">
                                                    <input
                                                        type="text"
                                                        className="input"
                                                        placeholder="Email "
                                                        value={Email}
                                                        onChange={(e) =>
                                                            this.setState({ Email: e.target.value })
                                                        }
                                                        onKeyDown={(e) => this.handleKeyDown(e)}
                                                        maxLength={50}
                                                    />
                                                    <div style={{ overflow: "hidden" }}>
                                                        <input
                                                            type={is_showpass ? "text" : "password"} // Change "type" to "text" when is_showpass is true
                                                            class="input"
                                                            placeholder="Password"
                                                            value={password}
                                                            onChange={(e) => this.setState({ password: e.target.value })}
                                                            onKeyDown={(e) => this.handleKeyDown(e)}
                                                            maxLength={25}
                                                        />
                                                        <i style={{
                                                            color: "black",
                                                            position: "relative",
                                                            fontSize: "20px",
                                                            top: "-44px",
                                                            left: "290px",
                                                            cursor: "pointer"
                                                        }}
                                                            className={`fa ${is_showpass ? "fa-eye-slash" : "fa-eye"} show-password`} // Use "fa-eye-slash" when is_showpass is true
                                                            onClick={() => this.setState((prevState) => ({ is_showpass: !prevState.is_showpass }))} // Toggle is_showpass state
                                                        ></i>
                                                    </div>
                                                    <input
                                                        type="checkbox"
                                                        class="checkbox"
                                                        id="remember_me"
                                                    />
                                                    <label for="remember_me">Remember me</label>
                                                    <a
                                                        class="btn btn-primary login_btn"
                                                        onClick={(e) => this.handleSubmit(e)}
                                                    >
                                                        Login
                                                    </a>
                                                    {/* <a class="btn btn-primary login_btn">Login</a> */}
                                                    {/* <!-- <input type="submit" class="button" value="Login"> --> */}
                                                </div>
                                                <div class="help-action">
                                                    <p>
                                                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <a
                                                            class="forgot"
                                                            style={{
                                                                textDecoration: "none",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={this.toggleModal}
                                                        >
                                                            Forgot your password?
                                                        </a>
                                                    </p>
                                                </div>
                                            </div>
                                            }
                                            {/* <!-- TABS CONTENT SIGNUP --> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </>
                {/* <Footerlogin /> */}
            </>
        );
    }
}

export default withRouter(
    connect(null, {
        login_action,
        forgetPassword_action,
        getOtp_action,
        update_action,
        booking_Details_action,
        signUp_action
    })(PreLogin)
);
